import { Component, OnInit } from '@angular/core';
import { ErrorMessageService } from '../../../../shared/error-message.service';
import { AdvisingAntifraudService } from '../../../services/advising-antifraud.service';

@Component({
    selector: 'app-setting-validation-advising-antifraud',
    templateUrl: './setting-validation-advising-antifraud.component.html',
    styleUrls: ['./setting-validation-advising-antifraud.component.scss']
})
export class SettingValidationAdvisingAntifraudComponent implements OnInit {
    forms: any[] = null;
    saving = false;

    constructor(private errorMessage: ErrorMessageService, private discardAntifraudService: AdvisingAntifraudService) {}
    ngOnInit() {
        this.discardAntifraudService.getConfigValidatorList().subscribe(validators => {
            if (validators) {
                this.forms = validators;
            }
        });
    }

    save() {
        this.saving = true;

        if (this.forms.length > 0) {
            this.forms.forEach(form => {
                this.discardAntifraudService.updateConfigValidator(form).subscribe(
                    resp => {
                        if (resp) {
                            this.errorMessage.showSuccess(`El validador ${form.description} ha sido actualizado`);
                        } else {
                            this.errorMessage.showError(
                                `No se puedo actualizar el validador ${form.description} debido a un error`
                            );
                        }
                    },
                    error => {
                        this.errorMessage.showError(error.error.error.show_message);
                    }
                );
            });
        }
        this.saving = false;
    }
}
